(ns common.localization-fi
  (:require
   [common.localization-en :as localization-en]))

(def translations-fi
  {:add-ubo                                        "Lisää tosiasiallinen edunsaaja"
   :add-pep                                        "Lisää poliittisesti vaikutusvaltainen henkilö"
   :add-new                                        "Lisää uusi"
   :add-at-least-n-board-members                   "Lisää ainakin %s hallituksen jäsentä"
   :add-column                                     "Lisää sarake"
   :remove-last-column                             "Poista viimeinen sarake"
   :add-tax-country                                "Lisää verotusmaa"
   :add-nationality                                "Lisää kansalaisuus"
   :edit-nationality                               "Muokkaa kansalaisuutta"
   :nationality                                    "Kansalaisuus"
   :national-id-number                             "Henkilötunnus"
   :address-data-found
   "Osoitetietoja löytyi. Tarkista tietojen paikkaansapitävyys Osoitetiedot -osiosta."
   :add-tin-or-missing-reason                      "Lisää veronumero tai selite"
   :and-x-more-missing-fields                      "ja %s muuta pakollista kenttää."
   :attachment-delete
   "Olet poistamassa tiedostoa. Tiedoston poistaminen ei poista tiedostosta mahdollisesti tehtyjä kopioita."
   :attention                                      "Huomio"
   :board-member                                   "Hallituksen jäsen"
   :board-member-add                               "Lisää hallituksen jäsen"
   :board-member-edit                              "Muokkaa hallituksen jäsenen tietoja"
   :board-members-found
   "Löysimme %s hallituksen jäsentä tälle yritykselle. Vahvisthan tietojen paikkaansapitävyyden Hallituksen jäsenet -osiosta."
   :board-member-missing-data                      "Täytä kaikki hallituksen jäsenen tiedot ennen vahvistusta"
   :board-members-missing-data                     "Täytä kaikkien hallituksen jäsenten tiedot ennen vahvistusta"
   :board-members-not-found
   "Emme löytäneet yhtään hallituksen jäsentä tälle yritykselle. Täytä tiedot manuaalisesti."
   :board-members-pending                          "Hallituksen jäseniä vahvistamatta"
   :cancel                                         "Peru"
   :cell-address                                   "Solu"
   :cancel-submission                              "Peru lähetys"
   :change-status                                  "Muuta tilaa"
   :email-is-mandatory                             "Syötä sähköpostiosoite"
   :download-submitted-answers-as-excel            "Lataa kopio vastauksistasi"
   :do-you-have-tax-identification-number-for-this-country?
   "Onko sinulla verotunnistenumero (TIN) tästä maasta?"
   :password-is-mandatory                          "Tarkista salasana"
   :transaction-process/pending-cannot-save-ready  "Pending-tilaa ei voi tallentaa valmiina."
   :transaction-process/pm-decision-blocked-by-danger-check
   "Ratkaise punaiset tarkistukset ennen PM-päätöksen kirjaamista."
   :transaction-process/decision-approval-not-permitted
   "Vain salkunhoitaja voi hyväksyä tämän päätöksen. Voit silti tallentaa sen luonnoksena."
   :transaction-process/decision-approved-locked
   "Tämä päätös on hyväksytty. Vain salkunhoitaja voi muuttaa sitä."
   :transaction-process/reserve-full-equity-amount
   "Varaa sijoitukselle koko oman pääoman määrä"
   :transaction-process/must-not-exceed-field
   "Arvo ei saa olla suurempi kuin %s"
   :transaction-process/reject-transaction          "Transaktio hylätty"
   :transaction-process/reject-transaction-confirmation
   "Vahvistan, että tämä transaktio on hylätty."
   :transaction-process/transaction-rejected        "Transaktio hylätty."
   :enrich-board-member-data                       "Hae hallituksen jäsenet"
   :enrich-address-data                            "Hae osoitetiedot"
   :error-check-business-id-and-country
   "Dataa haettaessa tapahtui virhe. Tarkistathan, että y-tunnus and yrityksen maa ovat oikein, ja yritä uudelleen."
   :error-something-went-wrong                     "Jokin meni vikaan. Ole hyvä ja yritä uudelleen."
   :check-business-id-and-country-tooltip          "Täytä y-tunnus ja yrityksen maa ensin"
   :clear                                          "Tyhjennä"
   :default                                        "Oletus"
   :grid                                           "Ruudukko"
   :gallery                                        "Galleria"
   :list                                           "Lista"
   :kanban                                         "Kanban"
   :kanban-column-item-count/one                   "%s kohde"
   :kanban-column-item-count/other                 "%s kohdetta"
   :kanban-loading-cards                           "Ladataan kortteja..."
   :kanban-not-configured-group-by-missing         "Kanbania ei ole määritetty: ryhmittelykenttä puuttuu."
   :kanban-group-by-reset-with-label               "Palauta (%s)"
   :kanban-column-grouping                         "Kanban-sarakkeiden ryhmittely"
   :kanban-column-sorting                          "Kanban-sarakkeiden lajittelu"
   :kanban-card-sorting                            "Kanban-korttien lajittelu"
   :linked-entity                                  "Liitetty entiteetti"
   :linked-entity-type                             "Liitetyn entiteetin tyyppi"
   :group-by                                       "Ryhmittele"
   :columns-by                                     "Sarakkeet"
   :columns-by-field                               "Sarakkeet: %s"
   :rows-by                                        "Rivit"
   :rows-by-field                                  "Rivit: %s"
   :row-grouping                                   "Rivien ryhmittely"
   :column-sort                                    "Sarakkeiden lajittelu"
   :card-sort                                      "Korttien lajittelu"
   :most-frequent                                  "Yleisimmät"
   :least-frequent                                 "Vähiten ensin"
   :numeric                                        "Numeerinen"
   :numeric-asc                                    "1-9"
   :numeric-desc                                   "9-1"
   :sort-az                                        "A-Z"
   :sort-za                                        "Z-A"
   :sort-title-az                                  "Otsikko A-Z"
   :sort-title-za                                  "Otsikko Z-A"
   :no-groupable-fields-found                      "Ryhmiteltäviä kenttiä ei löytynyt"
   :card-fields                                    "Kortin kentät"
   :card-field-settings                            "Kortin kenttäasetukset"
   :card-fields-display-limit                      "Kortit näyttävät enintään 3 valittua kenttää, tai 2 tiiviissä asettelussa."
   :show-labels                                    "Näytä otsikot"
   :reset-view                                     "Palauta näkymä"
   :uncategorized                                  "Luokittelematon"
   :on                                             "Päällä"
   :off                                            "Pois"
   :clear-form                                     "Tyhjennä lomake"
   :clear-select-option-label                      "-  Tyhjennä  -"
   :confirm-delete-selected
   "Olet poistamassa valitut kohteet. Toimintoa ei voi perua."
   :confirm-delete-selected-button                 "Poista"
   :confirm-delete-selected-count/one              "%s kohde poistetaan."
   :confirm-delete-selected-count/other            "%s kohdetta poistetaan."
   :confirm-delete-selected-count-changed          "Valinnan jälkeen osuvat kohteet ovat muuttuneet."
   :select-all-limit-exceeded                      "Valitse kaikki -ruudulla voi valita enintään %s kohdetta. Rajaa suodattimia ja yritä uudelleen."
   :select-all-resolve-failed                      "Valittujen kohteiden lataus epäonnistui. Yritä uudelleen."
   :confirm-delete-selected-checkbox               "Ymmärrän."
   :survey-status-wip                              "Kesken"
   :survey-status-waiting                          "Ei vielä käsiteltävänä"
   :survey-status-submitted                        "Lähetetty"
   :switch-to-another-survey                       "Vaihda kyselyä"
   :switch-to-another-survey-from-thank-you        "Tarkastele kyselyitä"
   :close-without-saving                           "Sulje tallentamatta"
   :conditional                                    "Ehdollinen"
   :confirm                                        "Vahvista"
   :confirm-all                                    "Vahvista kaikki"
   :confirm-board-members-to-continue
   "Vahvista tai poista hallituksen jäsenet ennen kuin voit jatkaa"
   :confirm-close-kyc-modal-without-saving
   "Et ole tallentanut muutoksia, haluatko jatkaa tallentamatta?"
   :constraint/string-max-length                   "Enimmäispituus %s merkkiä"
   :constraint/string-min-length                   "Vähimmäispituus %s merkkiä"
   :constraint/string-min-and-max-length           "Vähintään %s merkkiä ja enintään %s merkkiä"
   :continue                                       "Jatka"
   :contact-us-for-help                            "Pyydä apua"
   :you-can-fill-the-survey-in-exel                "Haluatko syöttää vastaukset Exceliin?"
   :download-excel-template                        "Lataa Excel-pohja"
   :data-enrichment-not-available-for-country      "Dataa ei ole saatavilla valitusta maasta"
   :data-found                                     "Löysimme tietoja"
   :data-not-found                                 "Tietoja ei löytynyt"
   :data-not-found-check-business-id-and-country
   "Tietoja ei löytynyt. Tarkista, että Y-tunnus ja yrityksen maa ovat oikein ja yritä uudelleen."
   :delete                                         "Poista"
   :delete-confirmation-body-text                  "Poista %s '%s'"
   :delete-board-member                            "Poista hallituksen jäsen"
   :delete-board-member-confirmation               "Haluatko varmasti poistaa hallituksen jäsenen pysyvästi?"
   :delete-permanently                             "Poista pysyvästi"
   :dropzone-instructions-post-link                "."
   :dropzone-instructions-pre-link                 "Pudota tiedostot tähän tai "
   :dropzone-instructions-link                     "valitse tiedosto"
   :edit-form                                      "Muokkaa"
   :enter-phone-number                             "Puhelinnumero"
   :enter-email-for-login                          "Sähköpostiosoite"
   :enter-phone-for-login                          "Puhelinnumero"
   :enter-phone-number-in-i18n-format              "Syötä kansainvälisessä muodossa +358..."
   :enter-code-received-as-sms                     "Syötä SMS varmistuskoodi"
   :enter-code-received-via-email                  "Syötä sähköpostilla saamasi koodi"
   :enter-email-code-info                          "Saat kohta varmistuskoodin sähköpostiisi"
   :enter-sms-code-info                            "Saat kohta varmistuskoodin tekstiviestillä"
   :exit                                           "Lopeta"
   :expand-table                                   "Laajenna taulukko"
   :select-placeholder                             "Valitse ..."
   :file-upload-error-label                        "Virhe tiedoston lataamisessa"
   :file-upload-indicator-label                    "Ladataan tiedostoa..."
   :file-not-uploaded                              "Tiedosto puuttuu"
   :fix-form-errors-to-continue                    "Korjaa lomakkeen virheet ennen kuin jatkat"
   :i-understand-theres-no-undo-for-this           "Ymmärrän ettei toimintoa voi perua."
   :invalid-email-code                             "Virheellinen koodi"
   :invalid-email                                  "Virheellinen sähköpostiosoite"
   :invalid-emails                                 "Kaikkien sähköpostiosoitteiden tulee olla oikeassa muodossa"
   :invalid-sms-code                               "Virheellinen koodi"
   :kyc-approve-set-approval-date-text
   "Aseta hyväksymispäivämäärä. Uusimispäivä lasketaan lisäämällä hyväksymispäivämäärään ja riskiluokituksen vuosien määrä."
   :kyc-invitation-subject                         "%s | asiakastietokysely"
   :capman-kyc-invitation-subject                  "CapMan | Asiakastietokysely (KYC)"
   :capman-kyc-reminder-subject                    "Muistutus: CapMan | Asiakastietokysely (KYC)"
   :kyc-invitation-angel-co-investment             "Kanssasijoitusrahasto"
   :tenant-kyc-invitation-subject                  "Kutsu suorittamaan vuokralaisen tuntemisprosessi (KYC)"
   :capman-contract-kyc-invitation-subject         "Kutsu suorittamaan vastapuolen tuntemisprosessi (KYC)"
   :sending-e-signature-request-failed             "Sähköisen allekirjoituspyynnön lähettäminen epäonnistui."
   :tenant-kyc-industry-desc-1                     "Toimialaluokittelulista löytyy tämän linkin takaa: "
   :tenant-kyc-industry-desc-2
   "Kopioi ja liitä oikea toimialan luokituskoodi ja nimi toimiala kenttään (esim. 01.12 - Riisin viljely)."
   :tenant-kyc-industry-desc-3                     ""
   :separator-                                     "Erotin [%s]"
   :thousand-separator                             "Tuhaterotin"
   :thousand-separator/none                        "Ei erotinta"
   :thousand-separator/space                       "Välilyönti ( )"
   :thousand-separator/comma                       "Pilkku (,)"
   :thousand-separator/period                      "Piste (.)"
   :thousand-separator/apostrophe                  "Heittomerkki (')"
   :decimal-separator                              "Desimaalierotin"
   :decimal-separator/comma                        "Pilkku (,)"
   :decimal-separator/period                       "Piste (.)"
   :kyc-exit-tooltip                               "Kaikki muutokset on tallennettu, voit kirjautua ulos."
   :kyc-exit-confirmation
   "Haluatko kirjautua ulos? Suljemme selaimen välilehden. Voit tarvittaessa kirjautua uudelleen samalla linkillä, jolla avasit lomakkeen."
   :kyc-template/kyc-form-title                    "Asiakastietokysely"
   :kyc-form-submitted-title                       "Kiitos, asiakastietolomake on vastaanotettu."
   :kyc-form-fields-not-filled-single              "%s on pakollinen tieto"
   :kyc-form-fields-not-filled                     "%s ja %s vastausta puuttuu"
   :kyc-wip-need-help?                             "Voit ottaa yhteyttä sähköpostilla:"
   :loading-indicator                              "Ladataan..."
   :login-using                                    "Kirjaudu sähköpostiosoitteella"
   :logout                                         "Kirjaudu ulos"
   :language                                       "Kieli"
   :mandatory-field                                "Pakollinen kenttä"
   :missing-signer-email                           "Lisää allekirjoittajan sähköpostiosoite ennen kuin voit jatkaa"
   :no                                             "Ei"
   :no-lp-portal-access                            "Ei käyttöoikeutta."
   :no-board-members                               "Ei"
   :no-ubos                                        "Ei"
   :no-peps                                        "Ei"
   :name                                           "Nimi"
   :no-changes                                     "Ei muutoksia"
   :deprecated-value-please-reselect               "Tämä vaihtoehto ei ole enää käytössä. Valitse toinen vaihtoehto."
   :data-missing                                   "Tietoja puuttuu"
   :no-questions                                   "Ei kysymyksiä"
   :once-you-have-filled-form                      "Syötettyäsi pyydetyt tiedot "
   :percentage                                     "Prosenttiosuus"
   :problems-signing-in?                           "Ongelma sisäänkirjautumisessa?"
   :phone-number-format                            "Syötä muodossa (+358 1111 111)"
   :portfolio-investment-category                  "Varallisuusluokitus"
   :remove                                         "Poista"
   :resend-sms-verification                        "Lähetä uusi tekstiviesti"
   :resend-code                                    "Lähetä uusi koodi"
   :re-invitation-sent                             "Viesti lähetetty"
   :send                                           "Lähetä"
   :sending                                        "Lähetetään"
   :send-reminder                                  "Lähetä muistutus"
   :send-email-code                                "Lähetä koodi sähköpostilla"
   :save                                           "Tallenna"
   :save-as-excel                                  "Tallenna Excelinä"
   :save-as-excel-all-data                         "Tallenna Excelinä (kaikki tiedot)"
   :save-as-pdf                                    "Tulosta PDF"
   :kyc-signatures-file                            "Allekirjoitettu PDF tiedosto"
   :kyc-to-protect-your-information-activate-sms-verification
   "Turvataksemme kirjautumisen jatkossa, pyydämme aktivoimaan tekstiviestillä tapahtuvan tunnistautumisen. Syötä alle puhelinnumero johon haluat vahvistus tekstiviestit."
   :kyc-print-and-sign                             "Tulosta ja allekirjoita"
   :kyc-send-for-esign                             "Lähetä allekirjoitettavaksi"
   :kyc-template-pdf-name-entity                   "Kanssasijoitusrahasto - Yhteisö - KYC tiedot.pdf"
   :kyc-template-pdf-name-individual               "Kanssasijoitusrahasto - Henkilö - KYC tiedot.pdf"
   :kyc-template-pdf-name-target-company           "Kohdeyhtiö - KYC tiedot.pdf"
   :set-as-ubo-short                               "Lisää TE"
   :set-as-ubo-long                                "Lisää henkilö tosiasialliseksi edunsaajaksi"
   :sign                                           "Allekirjoita"
   :signature-1                                    "Allekirjoitus 1"
   :signature-2                                    "Allekirjoitus 2"
   :submit                                         "Lähetä"
   :save-and-submit                                "Tallenna & lähetä"
   :survey-logout-button                           "Sulje"
   :survey-form.style/form                         "Lomake"
   :survey-form.style/grid                         "Taulukko"
   :survey-form.style/grid-full                    "Iso taulukko"
   :survey-to-excel                                "Exceliin"
   :survey-response-label                          "Vastaus %s"
   :survey-num-fmt-modal-title                     "Huomio!"
   :info-text-for-selecting-decimal-separator      "Voit syöttää numeerisiin kenttiin vain numeroita, tuhaterottimia sekä enintään yhden desimaalierottimen. Tämä koskee sekä käsin syötettyä tietoa että leikepöydältä kopioitua sisältöä. \nValitse alla olevista vaihtoehdoista haluamasi tuhaterotin ja desimaalierotin."
   :info-text-for-selecting-decimal-separator-note "Huomio: Tämä asetus koskee myös leikepöydältä liitettyjä tietoja. Jos kopioit tietoja Excelistä, suosittelemme valitsemaan asetukset, jotka vastaavat Excelin asetuksiasi."
   :info-text-missing-answers                      "Tarkista seuraavat pakolliset kysymykset :"
   :survey-number-format                           "Numeroformaatti"
   :number-format/comma-period                     "Pilkku ',' ja piste  '.' [%s]"
   :number-format/period-comma                     "Piste  '.' ja pilkku ',' [%s]"
   :number-format/space-period                     "Väli   ' ' ja piste  '.' [%s]"
   :number-format/space-comma                      "Väli   ' ' ja pilkku ',' [%s]"
   :survey-save-in-preferences-do-not-ask-again    "Tallenna äläkä kysy enää."
   :survey-loading-excel-modal-title               "Ladataan Excel tiedostoa"
   :survey-reporting-period                        "Raportointijakso"
   :survey-remove-modal-title                      "Vahvista sarakkeen poisto"
   :delete-last-series-button                      "Poista viimeinen sarake pysyvästi"
   :you-are-about-to-delete-survey-row             "Haluatko varmasti poistaa taulukon viimeisen sarakkeen? Kaikkien käyttäjien tekemät muutokset, olivatpa ne tallennettuja tai tallentamattomia, menetetään pysyvästi."
   :survey-submit-modal-title                      "Vahvista lähetys"
   :you-are-about-to-submit-survey-row             "Huomaa, että kun lähetät vastauksesi, niitä ei voi enää muokata. Voit kuitenkin ladata kopion vastauksistasi lomakkeen lähettämisen jälkeen."
   :load-survey-from-excel                         "Excelistä"
   :submit-survey-button                           "Lähetä vastaukset"
   :success                                        "Valmis"
   :show-in-excel                                  "Avaa Excelissä"
   :some-excel-cells-could-not-be-resolved         "Excelin soluissa (%s) virheellistä dataa"
   :cannot-resolve-option-value-from               "Virheellinen vaihtoehto- received '%s'"
   :cannot-resolve-numeric-value                   "'%s' ei ole numero"
   :cannot-resolve-boolean-value-from              "'%s' ei ole boolean arvo"
   :cannot-resolve-date-value                      "'%s' ei ole päivämäärä"
   :cannot-resolve-data-type                       "Tuntematon datatyyppi %s"
   :reference-period                               "Reference period"
   :reference-period/month                         "Kuukausi"
   :reference-period/quarter                       "Vuosineljännes"
   :reference-period/half-year                     "Vuosipuolisko"
   :reference-period/year                          "Vuosi"
   :source-of-fund-category                        "Varojen alkuperä"
   :submit-for-review-and-e-sign                   "Tarkistus ja sähköinen allekirjoitus"
   :tax-country                                    "Verotusmaa"
   :tax-country-tax-id                             "TIN (Veronumero - Tax identification number)"
   :tax-country-tax-id-short                       "TIN"
   :tax-country-tax-id-missing                     "Jos yhteisö ei voi ilmoittaa veronumeroa, ilmoita syy:"
   :tax-country-tax-id-missing-short               "Kommentti"
   :time-frame                                     "Aikaväli"
   :ubo-print                                      "Tosiasiallinen edunsaaja %s %s"
   :fill-business-id-and-country                   "Syötä Y-tunnus ja yrityksen maa ensin"
   :pep-print                                      "Poliittisesti vaikutusvaltainen henkilö %s"
   :valid-docs                                     "Asiakirja voimassa?"
   :validate-form                                  "Tarkista lomake"
   :validation.error/at-least-one-nationality-and-national-id-required
   "Lisää vähintään yksi kansalaisuus ja henkilötunnus"
   :validation.error/nationality-and-national-id-required
   "Jokaiselle kansalaisuudelle on annettava henkiötunnus/id"
   :validation.error/total-must-equal-100%         "Prosenttiosuuksien summan on oltava 100%"
   :waiting-for-signatories                        "Sopimus on lähetetty osapuolille. Odotetaan allekirjoituksia."
   :webform-input-errors                           "Syötetyissä tiedoissa on virheitä. Korjaa virheet ja syötä uudelleen."
   :webform-processing-info                        "Tietoja tallennetaan, tämä voi kestää hetken. Odota ole hyvä..."
   :webform-select-placeholder                     "--- Valitse ---"
   :webform-mandatory-error                        "Pakollinen kenttä"
   :transaction-process/transactions               "Transaktiot"
   :transaction-process/start-ic-process           "Käynnistä IC-prosessi"
   :transaction-process/no-target-transactions     "Ei vielä transaktioprosesseja, voit luoda sellaisen klikkaamalla yllä olevaa kuvaketta."
   :transaction-process/ic-decision-not-needed     "IC-päätöstä ei tarvita"
   :transaction-process/backward-transition-title  "Palaa edelliseen vaiheeseen"
   :transaction-process/backward-transition-warning
   "Palaaminen vaiheeseen %s poistaa myöhempien vaiheiden kentät ja asiakirjat."
   :transaction-process/backward-transition-confirmation
   "Ymmärrän, että myöhempien vaiheiden tiedot poistetaan."
   :yes                                            "Kyllä"
   :go-to-test-page                                "Siirry testisivulle"
   :webentry/attachments-title                     "Liitteet (enintään 50 MB)"})

(def translations
  (merge localization-en/translations
         translations-fi))
